module.exports = __webpack_public_path__ + "img/reaction.baa1f74f.svg";